import styles from './hero.module.css';
import sukklur from '../../../media/sukklur.jpeg';

const Hero = () => {
    return (
        <div className={styles.heroContainer}>
            <img className={styles.heroImage} src="https://images.unsplash.com/photo-1628603998251-97ed09883d64" alt="Cycling Hero" />
            <h1 className={styles.heroTitle}></h1>
        </div>
    );
}

export default Hero;
